import styled from 'styled-components'

import { mq, sizes } from '../../../theme'

export const Title = styled.div`
  display: flex;
  text-align: center;
  position: relative;
  ${({ theme }) => theme.textStyles.text_bold_20};

  @media ${mq(sizes.tablet)} {
    white-space: nowrap;
  }

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_bold_24};
  }

  &:before,
  &:after {
    border-top: 0.1rem solid ${({ theme }) => theme.colors.alto};
    content: '';
    display: flex;
    position: relative;
    width: 45%;
    top: 0.6em;
  }

  &:before {
    right: 1.5%;
  }

  &:after {
    left: 1.5%;
  }
`
